import React from 'react';
import { NavLink } from 'react-router-dom';

var bnr1 = require('./../../images/background/bg-6.png');

const Specialization = () => {
  return (
    <>
      <div className="section-full p-t80 p-b50 bg-dark mobile-page-padding" style={{ backgroundImage: "url(" + bnr1 + ")" }}>
        <div className="container">
          {/* IMAGE CAROUSEL START */}
          <div className="section-content">
            <div className="section-head m-b50 text-white text-center">
              <h3 className="m-t0">How do we convert dreams into reality?</h3>
              {false && <p>Wisi enim ad minim veniam, quis nostrud exerci tation ullamcorperadipiscing elit, sed diam nonummy
                nibh suscipit lobortis nisl ut aliquip ex ea commodo consequat.</p>}
            </div>
            <div className="row">
              <div className="col-md-4 col-sm-6 m-b30">
                <div className="image-effect-one hover-shadow">
                  <img src={require('../../images/specialization/Consultation.jpg')} alt="" />
                  <div className="figcaption">
                    <h4>Consultation</h4>
                    <p>We understand your vision, needs, and budget.</p>
                    {false && <NavLink to="/project-detail"><i className="link-plus bg-primary" /></NavLink>}
                  </div>
                </div>
              </div>
              <div className="col-md-4 col-sm-6 m-b30">
                <div className="image-effect-one hover-shadow">
                  <img src={require('../../images/specialization/Design-and-Planning.jpg')} alt="" />
                  <div className="figcaption">
                    <h4>Design \& Planning</h4>
                    <p>Detailed layouts, material selection, and scheduling.</p>
                    {false && <NavLink to="/project-detail"><i className="link-plus bg-primary" /></NavLink>}
                  </div>
                </div>
              </div>
              <div className="col-md-4 col-sm-12 m-b30">
                <div className="image-effect-one hover-shadow">
                  <img src={require('../../images/specialization/Execution.png')} alt="" />
                  <div className="figcaption bg-dark">
                    <h4>Execution</h4>
                    <p>Skilled craftsmanship with clean, efficient workflow.</p>
                    {false && <NavLink to="/project-detail"><i className="link-plus bg-primary" /></NavLink>}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Specialization;
